export default __webpack_public_path__ + "static/media/married.6e76bd92.svg";